module.exports = __webpack_public_path__ + "media/images/lb/238-f19930efce5066469e275d67f278f499.svg";